module.exports = __webpack_public_path__ + "bfcfd9bb8648fcc49e52f09bb9d2c01c.jpg";